import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { getGroups } from 'actions/groups';
import { dateFilterAllSubmittedOrders } from 'actions/orders';
import Breadcrumb from 'pages/sales-report/Breadcrumb';
import Filters from 'pages/sales-report/Filters';
import { Container, PaginationWrapper } from 'styles/pages/sales-report';
import SalesTable from 'pages/sales-report/table';
import Pagination from 'components/Pagination';
import { useLocation } from 'react-router-dom';
import { ROUTES } from 'shared/constants/routes';

const SalesReport = () => {
  const location = useLocation();
  const isAdmin = location?.pathname === ROUTES.ADMIN_SALES_REPORT.LINK;
  const dispatch = useDispatch();
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const [groups, setGroups] = useState(undefined);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [group, setGroup] = useState(undefined);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchGroups = async () => {
      const data = await dispatch(getGroups());
      setGroups(data);
    };

    if (groups === undefined) {
      fetchGroups();
    }
  }, [dispatch, groups]);

  return (
    <Container>
      <Breadcrumb />

      <p
        style={{
          color: 'red',
          margin: '0 0 0 15px',
          fontSize: 14,
          fontWeight: 'bold',
        }}
      >
        Currency conversion doesn't effect Sales report because in sales report
        bith currency already mentioned
      </p>
      <Filters
        isAdmin={isAdmin}
        startDate={startDate}
        groups={groups}
        endDate={endDate}
        group={group}
        onChange={(key, value) => {
          if (key === 'startDate') {
            setStartDate(value);
          } else if (key === 'endDate') {
            setEndDate(value);
          } else {
            setGroup(value);
          }
        }}
        generateReport={async () => {
          setCurrentPage(1);
          const response = await dispatch(
            dateFilterAllSubmittedOrders({
              skip: 0,
              take: 10,
              startDate: moment(startDate).subtract(1, 'days'),
              endDate: moment(endDate).add(1, 'days'),
              Group: group ? group?.name : undefined,
              user: !isAdmin ? emailid : undefined,
            })
          );
          if (response?.error) {
            return;
          }
          setData(response);
        }}
        data={data}
      />

      {data?.orders && (
        <div style={{ margin: 15 }}>
          <SalesTable data={data?.orders} />
        </div>
      )}

      {data?.orderCounts?.TotalOrders > 10 && (
        <PaginationWrapper>
          <Pagination
            totalCount={data?.orderCounts?.TotalOrders}
            take={10}
            page={currentPage}
            onChange={async (e, v) => {
              setCurrentPage(v);
              const response = await dispatch(
                dateFilterAllSubmittedOrders({
                  skip: (v - 1) * 10,
                  take: 10,
                  startDate: moment(startDate).subtract(1, 'days'),
                  endDate: moment(endDate).add(1, 'days'),
                  Group: group ? group?.name : undefined,
                  user: !isAdmin ? emailid : undefined,
                })
              );
              if (response?.error) {
                return;
              }
              setData(response);
            }}
          />
        </PaginationWrapper>
      )}
    </Container>
  );
};

export default SalesReport;
